module.exports = __webpack_public_path__ + "static/media/product_bg3.3d2c4ed4.webp";